import React, { useState, useEffect } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import "./Food.css";

function Food() {
  const [foodItems, setFoodItems] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    async function fetchFoodItems() {
      try {
        const response = await axiosInstance.get('/foodItems/all', { timeout: 100000 });
        const visibleItems = response.data.filter(item => item.visibleToCustomer);
        setFoodItems(visibleItems);
      } catch (error) {
        // Error handling without console.log
      }
    }
    fetchFoodItems();
  }, []);

  const formatPrice = (price) => `$${price.toFixed(2)}`;

  const groupByCourse = (items) => {
    return items.reduce((groupedItems, item) => {
      (groupedItems[item.course] = groupedItems[item.course] || []).push(item);
      return groupedItems;
    }, {});
  };

  const toggleRow = (itemId) => {
    setExpandedRows(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const renderMobileRow = (item) => (
    <div 
      className={`mobile-food-row ${expandedRows[item._id] ? 'expanded' : ''}`}
      onClick={() => toggleRow(item._id)}
    >
      <div className="mobile-food-main">
        <div className="mobile-food-left">
          <div className="mobile-food-name">
            {item.name}
            {item.isSpecial && <span className="special-stamp">Special</span>}
          </div>
          {!expandedRows[item._id] && (
            <div className="mobile-food-prompt">
              Click to see more details
            </div>
          )}
        </div>
        <div className="mobile-food-details">
          <div className="mobile-food-detail">
            <span className="detail-label">Price:</span>
            <span className="detail-value">{formatPrice(item.price)}</span>
          </div>
        </div>
      </div>
      {expandedRows[item._id] && (
        <div className="mobile-food-expanded">
          <div className="mobile-food-info">
            <div className="mobile-food-label">Description:</div>
            <div className="mobile-food-value">{item.description}</div>
          </div>
          <div className="mobile-food-info">
            <div className="mobile-food-label">Ingredients:</div>
            <div className="mobile-food-value">{item.ingredients.join(", ")}</div>
          </div>
          <div className="mobile-food-info">
            <div className="mobile-food-label">Dietary Types:</div>
            <div className="mobile-food-value">{item.dietaryTypes.join(", ") || "None"}</div>
          </div>
        </div>
      )}
    </div>
  );

  const groupedItems = groupByCourse(foodItems);

  const sortedCourses = Object.keys(groupedItems).sort((a, b) => {
    const order = ['Appetizer', 'Entree'];
    return order.indexOf(a) - order.indexOf(b);
  });

  return (
    <>
      <div className="food-menu">
        <h1>Food Truck Menu</h1>
        {sortedCourses.map((course) => (
          <div key={course} className="course-section">
            <h2>{course}s</h2>
            {isMobile ? (
              <div className="mobile-foods-container">
                {groupedItems[course].map((item) => (
                  <div key={item._id}>
                    {renderMobileRow(item)}
                  </div>
                ))}
              </div>
            ) : (
              <div className="food-menu-table-container">
                <table className="food-menu-table">
                  <thead>
                    <tr>
                      <th className="food-menu-header">Name</th>
                      <th className="food-menu-header">Description</th>
                      <th className="food-menu-header">Ingredients</th>
                      <th className="food-menu-header">Dietary Types</th>
                      <th className="food-menu-header">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedItems[course].map((item) => (
                      <tr key={item._id} className="food-menu-row">
                        <td className="food-menu-cell">
                          {item.name}
                          {item.isSpecial && <span className="special-stamp">Special</span>}
                        </td>
                        <td className="food-menu-cell">{item.description}</td>
                        <td className="food-menu-cell">{item.ingredients.join(", ")}</td>
                        <td className="food-menu-cell">{item.dietaryTypes.join(", ")}</td>
                        <td className="food-menu-cell">{formatPrice(item.price)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="food-decorative-div" style={{ 
        aspectRatio: "960/100", 
        backgroundImage: "url('/beigeToPinkFood.png')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      }}></div>
    </>
  );
}

export default Food;
